<template>
  <div>
    <el-form
      :model="EditForm"
      label-width="120px"
      :rules="EditFormRule"
      ref="EditFormRule"
      auto-complete="off"
    >
      <el-card shadow="hover" style="margin-top: 10px; width: 100%">
        <div slot="header" class="clearfix">
          <span>物流信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <el-link type="warning" v-if="this.viewtype > 0"
                >请正确核对物流信息</el-link
              >[{{ EditForm.loadCarNo }}]
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="柜型" prop="cabinetType">
              <el-select v-model="EditForm.cabinetType">
                <el-option
                  v-for="item in ContainerTypeList"
                  :label="item.text"
                  :value="item.text"
                  :key="item.text"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="柜号：" prop="containerNumber">
              <el-input
                v-model="EditForm.containerNumber"
                auto-complete="off"
                placeholder="请输入柜号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="封条号：" prop="sealNumber">
              <el-input
                v-model="EditForm.sealNumber"
                auto-complete="off"
                placeholder="请输入封条号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="SO：" prop="soNumber">
              <el-input
                v-model="EditForm.soNumber"
                auto-complete="off"
                placeholder="请输入SO"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="车牌：" prop="carNumber">
              <el-input
                v-model="EditForm.carNumber"
                auto-complete="off"
                placeholder="请输入车牌"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="司机：" prop="driver">
              <el-input
                v-model="EditForm.driver"
                auto-complete="off"
                placeholder="请输入司机"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话：" prop="driverPhone">
              <el-input
                v-model="EditForm.driverPhone"
                auto-complete="off"
                placeholder="请输入电话"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <el-card shadow="hover" style="margin-top: 10px; width: 100%">
        <div slot="header" class="clearfix">
          <span>装车数据</span>
        </div>

        <el-tabs class="warehouseTabs" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="中转" name="transit"></el-tab-pane>
      <el-tab-pane label="集货" name="collect"></el-tab-pane>
    </el-tabs >
          <div class="otherTable" v-show="transitVisible">
        <el-table
          :data="tableData"
          highlight-current-row
          border
          style="width: 100%;heiht"
        >
          <el-table-column prop="containerNo" label="货柜号"> </el-table-column>

          <el-table-column prop="transportType" label="运输方式">
          </el-table-column>
          <el-table-column prop="shippingNo" label="出库计划">
          </el-table-column>
          <el-table-column prop="sku" label="SKU/调入SKU">
            <template slot-scope="scope">
              {{ scope.row.sku }}/
              {{ scope.row.inStockSKUCode }}
            </template></el-table-column
          >

          <el-table-column prop="productNameCN" label="SKU名称">
          </el-table-column>
          <el-table-column prop="brand" label="品牌/型号">
            <template slot-scope="scope">
              {{ scope.row.brand }}/{{ scope.row.model }}
            </template>
          </el-table-column>
          <el-table-column label="FBA信息" min-width="140">
            <template slot-scope="scope">
              FNSKU： {{ scope.row.fnsku }}<br />
              SHIPMENTID: {{ scope.row.shipmentID }}<br />
              箱唛条码： {{ scope.row.barCodeName }}
            </template>
          </el-table-column>
          <el-table-column prop="fbaWarehouseCode" label="件数／箱号">
            <template slot-scope="scope">
              {{ scope.row.selCount }}<br />
              箱号：{{ scope.row.boxNo }}
            </template>
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="已发/未发/未发箱号"
            v-if="IsShowDeliver"
          >
            <template slot-scope="scope">
              {{ scope.row.scanDeliverNum }}/ {{ scope.row.scanNoDeliverNum
              }}<br />
              未发箱号:{{ scope.row.noSendBoxNo }}
            </template></el-table-column
          >
        </el-table>
          </div>


        <div class="otherTable" v-show="collectVisible">
        <el-table
          :data="tableCollectData"
          highlight-current-row
          border
          style="width: 100%;heiht"
        >
          <el-table-column
          prop="outboundNo"
          label="出库单号"
          align="center"
          sortable
        >
        </el-table-column>
          <el-table-column
          prop="orgOutboundNo"
          label="参考单号"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="containerNo"
          label="柜号"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="skuCode"
          label="SKU"
          sortable
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column prop="boxQty" label="箱数" sortable align="center">
        </el-table-column>
        <el-table-column
          prop="volume"
          label="体积"
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="重量"
          sortable
          align="center"
        >
        </el-table-column>
        </el-table>
          </div>

      </el-card>
      <el-card shadow="hover" style="margin-top: 10px; width: 100%">
        <div slot="header" class="clearfix">
          <span>装车照片</span>
        </div>
        <div class="demo-image">
          <ul v-for="(item, i) in srcList" :key="i">
            <div>
              <el-image
                :src="item"
                class="image-box"
                :preview-src-list="srcList"
              ></el-image>
            </div>
          </ul>
        </div>
      </el-card>
      <el-card
        shadow="hover"
        style="margin-top: 10px; width: 100%"
        v-if="this.viewtype > 0"
      >
        <div style="text-align: center">
          <el-button type="success" @click="passLoadingReview">通过</el-button>
          <el-button type="danger" @click="refuseLoadingReview">
            拒绝</el-button
          >
        </div>
      </el-card>
    </el-form>

    <el-dialog
      title="复核拒绝"
      :visible.sync="refusedialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="拒绝原因:">
          <el-input
            type="textarea"
            maxlength="100"
            placeholder="字数限制100"
            v-model="RefuseReason"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="refuseSubmit">保 存</el-button>
          <el-button @click="refusedialogVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPutOnCarLoadingReviewDataList,
  GetPutOnCarLoadingReviewImageList,
  PutOnCarReviewSubmit,
  GetPutOnCarLoadingReviewBoxInfo,
} from "@/api/outbound/loadingReview.js";

import { GetContainerTypeList } from "@/api/common/common.js";
import axios from "axios";
export default {
  data() {
    return {
      tableData: [],
      tableCollectData:[],
      IsShowDeliver: true,
      LoadCarInfo: {},
      srcList: [],
      ContainerTypeList: [],
      refusedialogVisible: false,
      RefuseReason: "",
      viewtype: 0,
      transitVisible:true,
      collectVisible:false,
      form: {},
      EditForm: {},
      EditFormRule: {
        carNumber: [{ required: true, message: "请输入", trigger: "blur" }],
        driver: [{ required: true, message: "请输入司机", trigger: "blur" }],
        cabinetType: [
          { required: true, message: "请选择柜型", trigger: "blur" },
        ],
        driverPhone: [
          { required: true, message: "请输入电话", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    //this.init();
  },
  methods: {
    handleClick() {
      if (this.activeName == 'transit') {
        this.transitVisible=true;
        this.collectVisible=false;
      } else {
        this.transitVisible=false;
        this.collectVisible=true;
      }
      console.log(this.transitVisible);
    },
    refusehandleClose() {},
    refuseSubmit() {
      const that = this;
      const loading = this.$loading({
        lock: true,
        text: "操作中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      const para = {
        loadCarInfoID: this.$route.query.loadCarInfoID,

        RefuseReason: this.RefuseReason,
        ReviewType: 2,
      };
      PutOnCarReviewSubmit(para).then((res) => {
        loading.close();
        if (res.success == true) {
          this.refusedialogVisible = false;
          this.$alert("保存成功", {
            confirmButtonText: "确定",
            callback: (action) => {
              window.parent.postMessage("close", "*");
            },
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        }
      });
    },
    passLoadingReview() {
      // if (this.tableData[0] == null || this.tableData[0].length <= 0) {
      //   this.$message({
      //     message: "没有装车单货柜信息",
      //     type: "error",
      //   });
      //   return false;
      // }

      if (this.EditForm.cabinetType!="无" && this.EditForm.cabinetType!="散装") {
        if (
          this.EditForm.containerNumber == "" ||
          this.EditForm.sealNumber == "" ||
          this.EditForm.soNumber == ""
        ) {
          this.$message({
            message: "填柜型时：柜号,封条号,SO不能为空!",
            type: "error",
          });
          return false;
        }
      }

      console.log(this.EditFormRule);
      this.$refs.EditFormRule.validate((valid) => {
        if (valid) {
          debugger;
          if (this.EditForm.carNumber != "") {
            let regcarNumber =
              /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/;
            if (!regcarNumber.test(this.EditForm.carNumber)) {
              this.$message({
                message: "请输入正确的车牌号，正确格式为（京A88888）",
                type: "error",
              });
              return false;
            }
          }

          if (this.EditForm.driverPhone != "") {
            let regdriverPhone =
              /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(14[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
            if (!regdriverPhone.test(this.EditForm.driverPhone)) {
              this.$message({
                message: "请输入正确的电话号码",
                type: "error",
              });
              return false;
            }
          }
          if (this.EditForm.referenceNo != "") {
            let regreferenceNo = /^[0-9a-zA-Z\-]*$/;
            if (!regreferenceNo.test(this.EditForm.referenceNo)) {
              this.$message({
                message:
                  "请输入正确的装车参考单号，正确格式为（ZC-2-210830-0001、ZC00001）",
                type: "error",
              });
              return false;
            }
          }

          let reg = /^[0-9a-zA-Z]*$/;
          if (this.EditForm.containerNumber != "") {
            if (!reg.test(this.EditForm.containerNumber)) {
              this.$message({
                message: "请输入正确的柜号，正确格式为字母、字数",
                type: "error",
              });
              return false;
            }
          }

          // if (this.EditForm.soNumber != "") {
          //   if (!reg.test(this.EditForm.soNumber)) {
          //     this.$message({
          //       message: "请输入正确的SO号，正确格式为字母、字数",
          //       type: "error",
          //     });
          //     return false;
          //   }
          // }

          var remindBoxNum = "";

          const loading2 = this.$loading({
            lock: true,
            text: "请稍等...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.5)",
          });
          GetPutOnCarLoadingReviewBoxInfo({
            loadCarInfoID: this.$route.query.loadCarInfoID,
          }).then((res) => {
            loading2.close();
            if (res.response) {
              remindBoxNum = "发货箱子数:" + res.response.shippedBoxNum + " ";
              remindBoxNum +=
                "不发箱子数:" + res.response.noShippedBoxNum + " ";
              remindBoxNum +=
                "未选择箱子数(未选择默认为不发货):" +
                res.response.noSelectBoxNum;
            }

            this.$confirm(remindBoxNum, "确认复核？", {})
              .then(() => {
                const loading = this.$loading({
                  lock: true,
                  text: "提交中，请稍等",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.5)",
                });

                const para = {
                  loadCarInfoID: this.$route.query.loadCarInfoID,
                  carNumber: this.EditForm.carNumber,
                  driverPhone: this.EditForm.driverPhone,
                  referenceNo: this.EditForm.referenceNo,
                  containerNumber: this.EditForm.containerNumber,
                  sealNumber: this.EditForm.sealNumber,
                  soNumber: this.EditForm.soNumber,
                  driver: this.EditForm.driver,
                  ReviewType: 1,
                  cabinetType: this.EditForm.cabinetType,
                };

                PutOnCarReviewSubmit(para).then((res) => {
                  loading.close();

                  if (res.success == true) {
                    this.$alert(res.msg, {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        window.parent.postMessage("close", "*");
                      },
                    });
                  } else {
                    this.$message({
                      message: res.msg,
                      type: "error",
                    });
                    return;
                  }
                });
              })
              .catch((err) => {
                console.log(err);
              });
          });
        }
      });
    },
    refuseLoadingReview() {
      const para = {
        loadCarInfoID: this.$route.query.loadCarInfoID,
      };
      this.refusedialogVisible = true;
    },

    init() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      const para = {
        //   loadCarInfoID: this.$route.query.loadCarInfoID,
        loadCarInfoID: this.$route.query.loadCarInfoID,
      };

      GetContainerTypeList({}).then((res) => {
        this.ContainerTypeList = res.data.response;
      });

      this.viewtype = this.$route.query.viewtype;

      GetPutOnCarLoadingReviewDataList(para).then((res) => {
        loading.close();
        if (res.response) {
          this.IsShowDeliver = res.response.status >= 40 ? true : false;
          if (res.response.loadCarDetailList) {
            this.tableData = res.response.loadCarDetailList;
            this.tableCollectData=res.response.outboundList;
          }
          var temparray = [];
          if (res.response.loadCarImageList) {
            res.response.loadCarImageList.forEach((item, i) => {
              temparray[i] = `data:image/png;base64,${item}`;
            });
            this.srcList = temparray;
          }

          this.LoadCarInfo = res.response;
          this.EditForm = res.response;
        }
      });

      GetPutOnCarLoadingReviewImageList(para).then((res) => {
        if (res.response) {
          
          var temparray = [];
          if (res.response.loadCarImageList) {
            res.response.loadCarImageList.forEach((item, i) => {
              temparray[i] = `data:image/png;base64,${item}`;
            });
            this.srcList = temparray;
          }

          
        }
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>

<style scoped lang="less">
.left-item {
  float: left;
  width: 20%;
  // min-width: 285px;
}
.left-item-card {
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}

el-input {
  width: 100px;
}

.left-item-card {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(207, 210, 217);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgb(184, 182, 182);
  }
}
.image-box {
  float: left;
  width: 20%;
  text-align: center;
  margin: 20px 100px;
  height: 200px;
}
.sign-photo-btn {
  width: 100px;
  border: 1px dashed #ccc;
  margin: 0 auto;
  height: 100px;
  cursor: pointer;
}
.sign-photo-btn:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.sign-photo-item:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.photo-s {
  color: #bfbfbf;
  padding: 23px 0;
  margin: 0;
  i {
    font-size: 55px;
  }
}
.sign-photo-item {
  height: 100px;
  width: 100px;
  margin: 0 auto;
  position: relative;
  img {
    height: 100px;
    width: 100px;
  }
}
.del-box {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    cursor: pointer;
    color: rgb(248, 248, 248);
    margin-top: 35px;
  }
}
.loading-box {
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    color: rgb(224, 222, 222);
    margin-top: 35px;
  }
}
.hidden {
  display: none;
}
</style>

<style>
.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>
